import request from 'utils/request';

const PREFIX = '/api/billing/adv/';

export const AdvertiserBillingAPI = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
  UPDATE: PREFIX + 'update',
  DELETE: PREFIX,
  DOWNLOAD: PREFIX + 'download',
  RECEIPT_STATUS: PREFIX + 'receipt-status',
  RECONCILIATION_PROGRESS: PREFIX + 'reconciliation-progress',
  DOWNLOAD_TEMPLATE: PREFIX + 'download/template',
};

export function getAdvertiserBillingList(data) {
  return request({
    url: AdvertiserBillingAPI.LIST,
    method: 'post',
    data,
  });
}

export function getReceiptStatusList() {
  return request({
    url: AdvertiserBillingAPI.RECEIPT_STATUS,
    method: 'get',
  });
}

export function getReconciliationProgressList() {
  return request({
    url: AdvertiserBillingAPI.RECONCILIATION_PROGRESS,
    method: 'get',
  });
}

export function addAdvertiserBilling(data) {
  return request({
    url: AdvertiserBillingAPI.ADD,
    method: 'post',
    data,
  });
}

export function deleteAdvertiserBillingById(id) {
  return request({
    url: AdvertiserBillingAPI.DELETE + id,
    method: 'delete',
  });
}

export function updateAdvertiserBilling(data) {
  return request({
    url: AdvertiserBillingAPI.UPDATE,
    method: 'put',
    data,
  });
}

export function downloadAdvertiserBilling(data) {
  return request({
    url: AdvertiserBillingAPI.DOWNLOAD,
    method: 'post',
    responseType: 'blob',
    data,
  });
}

export function downloadAdvertiserBillingTemplate() {
  return request({
    url: AdvertiserBillingAPI.DOWNLOAD_TEMPLATE,
    method: 'get',
    responseType: 'blob',
  });
}
